const URL_BASE=process.env.REACT_APP_API;

export const URL_COUNTRIES_LIST=`${URL_BASE}/country`;